import { create } from "zustand";
import { ItemData } from "../../operations/store/ManifestoStore";
import { ActionsKey } from "../../../common/models/Actions";
import { DefaultListStateType } from "../../../common/models/StoreDefaultModel";
import { initialStoragePageState } from "../../storages/core/_model.storage";

type DashBoardType = {
  list: Array<any>;
  totalItems: number;
  detail?: ItemData | null;
  actioned?: ActionedType | null;
  setDetail?: (detail: ItemData | null) => void;
  setActioned: (act: ActionedType | null) => void;
  pageState: any;
  setList?: (cont: any) => void;
};

export type ActionedType = {
  data: any;
  action: ActionsKey;
};

interface OperationFeatureStoreState {
  storageList: any[];
  totalItems?: number;
  detail: ItemData | null;
  actioned: ActionedType | null;
  setDetail: (detail: ItemData | null) => void;
  setStorageList: (saleData: { member: any[]; totalItems: number }) => void;
  setActioned: (act: ActionedType | null) => void;
}

export const useOperationCount = create<DashBoardType>((set) => ({
  list: [],
  totalItems: 0,
  detail: null,
  actioned: null,
  pageState: null,

  setDetail: (detail) => set((state) => ({ detail })),
  setList: (data) =>
    set(() => ({
      list: data?.member,
      totalItems: data?.totalItems,
    })),
  setActioned: (act) => set((state) => ({ actioned: act } as any)),
}));
export const useOperationDistribution = create<DashBoardType>((set) => ({
  list: [],
  totalItems: 0,
  detail: null,
  actioned: null,
  pageState: null,

  setDetail: (detail) => set((state) => ({ detail })),
  setList: (data) =>
    set(() => ({
      list: data?.member,
      totalItems: data?.totalItems,
    })),
  setActioned: (act) => set((state) => ({ actioned: act } as any)),
}));
export const useOperationSummary = create<DashBoardType>((set) => ({
  list: [],
  totalItems: 0,
  detail: null,
  actioned: null,
  pageState: null,

  setDetail: (detail) => set((state) => ({ detail })),
  setList: (data) =>
    set(() => ({
      list: data?.member,
      totalItems: data?.totalItems,
    })),
  setActioned: (act) => set((state) => ({ actioned: act } as any)),
}));

export const useOperationFeatureStore = create<OperationFeatureStoreState>(
  (set) => ({
    storageList: [],
    totalItems: 0,
    detail: null,
    actioned: null,

    setDetail: (detail: ItemData | null) => set((state) => ({ detail })),
    setStorageList: (saleData: { member: any[]; totalItems: number }) =>
      set((state) => ({
        storageList: saleData?.member,
        totalItems: saleData?.totalItems,
      })),
    setActioned: (act: ActionedType | null) =>
      set((state) => ({ actioned: act } as any)),
  })
);

export const useOperationFeature = create<DefaultListStateType>((set) => ({
  pageState: initialStoragePageState,
  setPageState: (pageState) => set((state) => ({ pageState })),
  resetPageState: () =>
    set(() => ({
      pageState: {
        page: 1,
        itemsPerPage: 10,
      },
    })),
}));
